import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

export const SacredGeometryGrid: React.FC<{ opacity?: number }> = ({ opacity = 1 }) => {
  const frame = useCurrentFrame();

  const drawProgress = interpolate(frame, [0, 90], [0, 1], { extrapolateRight: "clamp" });
  const rotation = frame * 0.05;

  // Flower of Life pattern: overlapping circles
  const circles: Array<{ cx: number; cy: number }> = [];
  const r = 40;
  // Center
  circles.push({ cx: 0, cy: 0 });
  // First ring
  for (let i = 0; i < 6; i++) {
    const angle = (i * 60 * Math.PI) / 180;
    circles.push({ cx: r * Math.cos(angle), cy: r * Math.sin(angle) });
  }
  // Second ring
  for (let i = 0; i < 6; i++) {
    const angle = ((i * 60 + 30) * Math.PI) / 180;
    circles.push({ cx: r * 1.73 * Math.cos(angle), cy: r * 1.73 * Math.sin(angle) });
  }

  return (
    <AbsoluteFill style={{ opacity, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <svg viewBox="-150 -150 300 300" width="70%" height="70%"
        style={{ position: "absolute", transform: `rotate(${rotation}deg)` }}>
        {circles.map((c, i) => {
          const circleProgress = interpolate(frame, [i * 4, i * 4 + 30], [0, 1], {
            extrapolateLeft: "clamp", extrapolateRight: "clamp",
          });
          const dashLen = 2 * Math.PI * r;
          return (
            <circle key={i}
              cx={c.cx} cy={c.cy} r={r}
              fill="none"
              stroke="#D4A843"
              strokeWidth={0.6}
              opacity={circleProgress * 0.5}
              strokeDasharray={dashLen}
              strokeDashoffset={dashLen * (1 - circleProgress)}
            />
          );
        })}
        {/* Connecting lines */}
        {drawProgress > 0.5 && circles.slice(1, 7).map((c, i) => {
          const next = circles[(i + 1) % 6 + 1];
          const lineOpacity = interpolate(drawProgress, [0.5, 0.8], [0, 0.3], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          return (
            <line key={`l${i}`}
              x1={c.cx} y1={c.cy} x2={next.cx} y2={next.cy}
              stroke="#F37021" strokeWidth={0.4} opacity={lineOpacity}
            />
          );
        })}
      </svg>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
